<template>
  <div class="m-collapse">
      <ul>
          <li v-for="(item,index) in collapse_data" :key="'c-' + index" :class="index == default_index ? 'act' : ''"
            @click="default_index=index">
            <div class="u-btn trriger" :class="'trriger-' + (index + 1)"></div>
            <div class="img-view">
              <img v-if="index == default_index" v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/collapse/'+ (default_index + 1) + '.png'" alt="">
            </div>
          </li>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  data () {
    return {
      collapse_data : [
        {
          title : '回归福利',
          img : '1',
        },
        {
          title : '活跃任务',
          img : '2',
        },
        {
          title : '回归签到',
          img : '3',
        },
        {
          title : '回归特惠',
          img : '4',
        },                                    
      ],
      default_index : 0,
      now : 0,
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.m-collapse ul{
  display: flex;
}

.m-collapse ul li{
  display: flex;
}

.m-collapse .trriger{
  width: 49px;
  height: 361px; 
}

.m-collapse .trriger.trriger-1{
  background-image: url(../images/swiper-1.png);
}

.m-collapse .act .trriger.trriger-1{
  background-image: url(../images/swiper-1-act.png);
}

.m-collapse .trriger.trriger-2{
  background-image: url(../images/swiper-2.png);
}

.m-collapse .act .trriger.trriger-2{
  background-image: url(../images/swiper-2-act.png);
}

.m-collapse .trriger.trriger-3{
  background-image: url(../images/swiper-3.png);
}

.m-collapse .act .trriger.trriger-3{
  background-image: url(../images/swiper-3-act.png);
}

.m-collapse .trriger.trriger-4{
  background-image: url(../images/swiper-4.png);
}

.m-collapse .act .trriger.trriger-4{
  background-image: url(../images/swiper-4-act.png);
}

.m-collapse .img-view{
  position: relative;
  width: 493px;
  height: 361px;
  background-image: url(../images/bg-img.png);
  width: 0;
  overflow-x: hidden;
}

.m-collapse .act .img-view{
  width: 493px;
}

.m-collapse .img-view img{
  display: block;
  position: absolute;
  width: 485px;
  height: 351px;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/collapse.vue